const ACTION_TYPES = {
  SET_SCENARIO: 'SET_SCENARIO',
  GO_TO_NEXT_STEP: "GO_TO_NEXT_STEP",
  GO_BACK_TO_PREV_STEP: "GO_BACK_TO_PREV_STEP",
  RESTART: "RESTART",
  RESET: "RESET",
};


const setScenario = (payload) => {
  return {
    type: ACTION_TYPES.SET_SCENARIO,
    payload,
  };
};


const  goToNextStep = (payload) => {
  return {
    type: ACTION_TYPES.GO_TO_NEXT_STEP,
    payload,
  };
};

const goBackToPrevStep = (payload) => {
  return {
    type: ACTION_TYPES.GO_BACK_TO_PREV_STEP,
    payload,
  };
};


const restart = (payload) => {
  return {
    type: ACTION_TYPES.RESTART,
    payload,
  };
};

const reset = (payload) => {
  return {
    type: ACTION_TYPES.RESET,
    payload,
  };
};

export { ACTION_TYPES, setScenario, goToNextStep, goBackToPrevStep, reset, restart };
